import { useController, useFormContext } from 'react-hook-form';
import { Flex, Dropdown } from '@creditas-ui/react';
import { useFieldEvents } from '~/utils/events/field-events';
import { getError } from '~/utils/getError';
import type { JSX } from 'react';
import type { FieldSelectSchema } from '~/shared/domain/models';

export type FieldSelectProps = {
  data: FieldSelectSchema;
};

type Component = (props: FieldSelectProps) => JSX.Element;

export const FieldSelect: Component = ({ data }) => {
  const { control } = useFormContext();
  const {
    name,
    label = '',
    messages: { error, helperText },
    disabled,
    options,
  } = data;
  const {
    field,
    formState: { errors },
  } = useController({
    name,
    control,
  });

  const optionsValues = options.map((option) => ({ text: option.label, value: option.value }));
  const { handleOnChange } = useFieldEvents();

  return (
    <Flex flexDirection="column">
      <Dropdown
        onChangeOption={(ev) => {
          field.onChange(ev.value);
          handleOnChange({
            element_name: name,
            element_value: ev.value,
            field_type: 'dropdown',
          });
        }}
        value={field.value}
        disabled={disabled}
        options={optionsValues}
        text={label}
        error={getError(errors[name], error)}
        helperText={helperText}
        tabIndex={0}
      />
    </Flex>
  );
};
